<template>
    <div class="compet-row">
      <div class="compet-row__1">
        <div class="compet-row__title">
          {{item.title}}
        </div>
        <div class="compet-row__blocks">
          <PersonalAbilityScale :color="item.color" :value="item.value" />
        </div>
      </div>
      <div class="compet-row__desc" v-html="prepareText(item.description)" />
      <div class="compet-row__desc-percentage" :style="{borderColor: item.color}" v-html="prepareText(item.percentage_description)" />
    </div>
</template>

<script>
import { prepareText } from '@/common/util';
import PersonalAbilityScale from './PersonalAbilityScale.vue';

export default {
  name: 'PersonalAbilityRow',
  components: {
    PersonalAbilityScale
  },
  props: ['item'],
  data: () => ({
  }),
  methods: {
    prepareText
  }
};
</script>

<style>
.compet-row {
    border-top: 0.5px solid #DEE1EA;
    padding: 0 20px 15px 0;
}

.compet-row__1 {
}

.compet-row__title {
  flex: 50% 0 0;
  font-weight: 600;
  padding: 35px 0 15px 0;
}

.compet-row__blocks {
  flex: 50% 0 0;
}

.compet-row__desc {
  margin-top: 10px;
  font-size: 0.9rem;
}

.compet-row__desc-percentage {
  margin-top: 10px;
  border-left: 3px solid;
  padding-left: 10px;
  font-weight: 600;
}
</style>
